import { normalize } from "normalizr";
import { camelizeKeys } from "humps";
import api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "../../actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import schemas from "../../utils/schemas";

export function loadGenericFilterParams(context) {
  return async (dispatch, getState) => {
    const projectionState = getState().genericFilterParams[context];
    let callApi =
      !projectionState ||
      !projectionState.genericFilterParams ||
      (!projectionState.genericFilterParams.loaded && !projectionState.genericFilterParams.loading);
    if (!callApi) return;

    dispatch({ type: actionTypes.LOAD_GENERICFILTERPARAMS_STARTED, context });

    try {
      const ctxt =
        context === "SUBLIMITFILTERS" || context === "SUBLIMITFINANCINGSTRUCTUREFILTERS" ? "LF_FILTER" : context;
      const response = await dispatch(sendHttpRequest(api.getGenericFilterParams(ctxt)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.genericFilterParams));
      dispatch({ type: actionTypes.LOAD_GENERICFILTERPARAMS_SUCCEEDED, context, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_GENERICFILTERPARAMS_FAILED, context, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadGenericFilterOperators(context) {
  return async (dispatch, getState) => {
    const projectionState = getState().genericFilterOperators[context];
    let callApi =
      !projectionState ||
      !projectionState.genericFilterOperators ||
      (!projectionState.genericFilterOperators.loaded && !projectionState.genericFilterOperators.loading);
    if (!callApi) return;

    dispatch({
      type: actionTypes.LOAD_GENERICFILTEROPERATORS_STARTED,
      context
    });

    try {
      const response = await dispatch(sendHttpRequest(api.getGenericFilterOperators()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.genericFilterOperators));
      dispatch({ type: actionTypes.LOAD_GENERICFILTEROPERATORS_SUCCEEDED, context, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_GENERICFILTEROPERATORS_FAILED, context, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadGenericFilterParamValuesWithoutRedux(paramId) {
  //no redux cache
  return () => api.getGenericFilterParamValues(paramId);
}
export function loadPagedGenericFilterParamValuesWithoutRedux(paramId, name, page) {
  //no redux cache
  return () => api.getPagedGenericFilterParamValues(paramId, name, page);
}

export function loadGenericFilterParamValues(context, paramId) {
  return async (dispatch, getState) => {
    const projectionState = getState().genericFilterParamValues.contexts[context]
      ? getState().genericFilterParamValues.contexts[context].genericFilterParamValues
      : null;
    let callApi = !projectionState || !projectionState.loaded || !projectionState.loading;
    if (!callApi) return;

    dispatch({
      type: actionTypes.LOAD_GENERICFILTERPARAMVALUES_STARTED,
      key: paramId,
      context
    });

    try {
      const response = await dispatch(sendHttpRequest(api.getGenericFilterParamValues(paramId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.genericFilterParamValues));
      dispatch({
        type: actionTypes.LOAD_GENERICFILTERPARAMVALUES_SUCCEEDED,
        key: paramId,
        context,
        ...payload
      });
    } catch (error) {
      dispatch({
        type: actionTypes.LOAD_GENERICFILTERPARAMVALUES_FAILED,
        key: paramId,
        context,
        error
      });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
